import React from "react";
import classnames from "classnames";
import stl from "./price.module.scss";
import { FmRating, FmTag } from "@/ui-component";
import { ColorItem } from "@/store/modules/productDetails";
import PriceClient from "./PriceClient";
import SalePerClient from "./SalePerClient";
import CountDownPrice from "@/src/productDetails/CountDownPrice";
import Title from "../Title";
import { ITitleProps } from "@/src/components/SearchDrawer/refund/Title";
import { useTranslation } from "@/src/i18n/client";
import { useRateContext } from "@/src/provider";
interface IProps extends ITitleProps {
    activeObj: ColorItem;
    advertising: Record<string, any>;
    starNum: number;
    commentNum: number;
    productDetail: Record<string, any>;
}
const Price: React.FC<IProps> = (props) => {
    const getPrice = useRateContext((state) => state.getPrice);
    const { activeObj, productDetail, advertising, starNum, commentNum } =
        props;
    const { t } = useTranslation('productDetail');
    const { onsale, price } = activeObj;
    const {
        title,
        start = 0,
        end = 0,
        opentit,
        visible,
        backgroundColor,
    } = advertising || {};
    //cms促销活动在时间范围内
    let is_show_cms_count =
        visible != "hidden" &&
        new Date().getTime() / 1000 > start &&
        new Date().getTime() / 1000 < end;
    return (
        <>
            {/* cms促销活动 */}
            {is_show_cms_count && (
                <CountDownPrice
                    now={Date.now() / 1000}
                    startTime={start}
                    lastTime={end}
                    title={title}
                    opentit={opentit}
                    backgroundColor={backgroundColor}
                />
            )}
            {/* 商品折扣 */}
            {!is_show_cms_count && onsale?.showDiscount && (
                <CountDownPrice
                    now={Date.now() / 1000}
                    startTime={price?.discount_start!}
                    lastTime={price?.discount_expire!}
                />
            )}

            <div>
                <div className={classnames(stl["product-price-container"])}>
                    {onsale?.showDiscount ? (
                        <div
                            className={classnames(
                                "default_layout",
                                stl["onsale-show-discount"],
                            )}
                        >
                            <div className={classnames(stl["price"])}>
                                <p className={classnames(stl["price-value"])}>
                                    {getPrice(onsale.price)}
                                </p>
                                <s>
                                    {getPrice(activeObj?.price?.price!)}
                                </s>
                            </div>
                            {onsale.salePer >= 0 && (
                                <FmTag
                                    backgroundColor="#EE5454"
                                    style={{
                                        marginLeft: "0.145rem",
                                    }}
                                >
                                    <SalePerClient salePer={onsale.salePer} />
                                </FmTag>
                            )}
                        </div>
                    ) : (
                        <span className={classnames(stl["product-price-now"])}>
                            {getPrice(onsale?.price!)}
                        </span>
                    )}
                    {productDetail.ageRange && (
                        <h4
                            style={{
                                marginLeft: "15px",
                                color: "#696161",
                            }}
                        >{`(${t("productDetail:Age")} ${productDetail.ageRange})`}</h4>
                    )}
                </div>

                {productDetail && (
                    <div
                        className={classnames(stl["page-item"])}
                        style={{
                            marginTop: 0,
                            paddingTop: "0.2rem",
                            width: "100%",
                        }}
                    >
                        <div
                            className={classnames(
                                "default_layout",
                                stl["product-detail-content"],
                            )}
                        >
                            <Title productDetail={productDetail} />
                            <PriceClient>
                                <FmRating
                                    iconClassName={stl["icon-rating"]}
                                    value={starNum}
                                    readOnly
                                    hiddenRatingNum
                                />
                                <span className={stl["comment-num"]}>
                                    {commentNum}
                                </span>
                            </PriceClient>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Price;
